// extracted by mini-css-extract-plugin
export var icon = "_6s-1";
export var subtext = "_6s-0";